import { Button } from '@ethsign/ui';
import { Header } from './Header';
import { openLink } from '@/utils/common';
import { ENVS } from '@/constants';

export const NotOpenPanel = () => {
  return (
    <div className={'bg-background p-4 min-h-[100vh]'}>
      <Header />
      <div className={'flex flex-col items-center pt-20 px-8'}>
        <div className={'w-full flex items-center justify-center mb-8'}>
          <img
            src={
              'https://sign-public-cdn.s3.us-east-1.amazonaws.com/TokenTable-Frontend/No Notification illustration_241112071457.webp'
            }
            alt=""
            className={'w-[128px]'}
          />
        </div>
        <div className={'text-primary-foreground text-xl font-bold'}>Airdrop Has not Started</div>
        <div className={'text-primary-foreground text-xs font-medium mt-2 text-center'}>
          You’re here early! 🤙 Hang tight and be ready to jump in when it goes live 🧡.
        </div>
        <Button
          className={'flex gap-2 px-6 mt-8'}
          onClick={() => {
            openLink(ENVS.CommunityUrl);
          }}
        >
          <img
            src={
              'https://sign-public-cdn.s3.us-east-1.amazonaws.com/TokenTable-Frontend/Social Icons_241113065919.webp'
            }
            className={'w-5 h-5'}
            alt=""
          />
          Join TokenTable Community
        </Button>
      </div>
    </div>
  );
};

export const ProjectEndPanel = () => {
  return (
    <div className={'bg-background p-4 min-h-[100vh]'}>
      <Header />
      <div className={'flex flex-col items-center pt-20 px-8'}>
        <div className={'w-full flex items-center justify-center mb-8'}>
          <img
            src={
              'https://sign-public-cdn.s3.us-east-1.amazonaws.com/TokenTable-Frontend/End illustration_241112071458.webp'
            }
            alt=""
            className={'w-[132px]'}
          />
        </div>
        <div className={'text-primary-foreground text-xl font-bold'}>Oops! It’s Closed</div>
        <div className={'text-primary-foreground text-xs font-medium mt-2 text-center'}>
          The TAC airdrop has ended. Discover more airdrops in TokenTable Community 🧡.
        </div>
        <Button
          className={'flex gap-2 px-6 mt-8'}
          onClick={() => {
            openLink(ENVS.CommunityUrl);
          }}
        >
          <img
            src={
              'https://sign-public-cdn.s3.us-east-1.amazonaws.com/TokenTable-Frontend/Social Icons_241113065919.webp'
            }
            className={'w-5 h-5'}
            alt=""
          />
          Join TokenTable Community
        </Button>
      </div>
    </div>
  );
};
